// v2-1379 : le jeton Space KO de Winamax.
//
// Le jeton de depart vaut exactement la moitie du buy-in total, rake compris. Mesure sur les
// dix tournois joints au ticket V2-1377, sur deux structures de buy-in (0,40+0,50+0,10 et
// 2+2,50+0,50) : dix fois sur dix. C'est ce qui permet de deduire le palier d'un joueur du
// seul montant de sa prime, sans rien ajouter au parsing ni a la base.
//
// Paliers 1 a 10 : multiple du buy-in total, la table publiee par Winamax.
// Paliers 11 a 14 : montants ABSOLUS en euros, et non des multiples. Un jeton legendaire a
// 500 000 EUR vaut x50 000 sur un tournoi a 10 EUR mais x5 000 sur un tournoi a 100 EUR :
// un bareme unique se tromperait de plusieurs paliers sur les gros buy-in.
const MULTIPLES = [0.5, 0.6, 0.75, 1, 1.5, 2.5, 5, 10, 20, 50];
const ABSOLUTES = [10000, 100000, 333333, 500000];

// Ce que rapporte l'elimination d'un joueur, rapporte a son propre jeton. Les deux bornes
// sont celles du widget de Winamax (palier 11 : min 4 000, moy 10 000, max 1 000 000). Le
// plancher est corrobore par la mesure : sur 46 eliminations relevees dans les historiques
// du ticket V2-1377, la croissance du jeton du vainqueur n'est jamais descendue sous x0,2
// du jeton de sa victime, soit x0,4 gagne dont la moitie est payee en especes.
export const MIN_RATIO = 0.4;
export const MAX_RATIO = 100;

/**
 * Le buy-in total d'une main, relu dans le texte deja mis en forme par le coeur.
 * ReplayHand.buyInText passe par XeesterUtils.getDecimalFloat, qui force la Locale US :
 * separateur decimal point, aucun groupement des milliers. La lecture est donc sure.
 * Renvoie 0 hors tournoi, en argent fictif, et quand le buy-in n'est pas connu ("-").
 */
export function buyInValue(hand) {
  if (!hand || typeof hand.buyIn !== "string") {
    return 0;
  }
  const value = parseFloat(hand.buyIn);
  return isFinite(value) && value > 0 ? value : 0;
}

/**
 * Le palier atteint par une prime, de 1 a 14. Renvoie 0 quand il n'est pas calculable :
 * pas de prime, ou buy-in inconnu pour les dix premiers paliers.
 *
 * La valeur du jeton est continue — elle grossit d'une fraction de chaque prime gagnee —
 * et ne tombe donc presque jamais pile sur un seuil. Le palier est la plus haute bande
 * atteinte, pas une egalite.
 */
export function tokenLevel(bounty, buyIn) {
  // Le buy-in est exige meme pour les paliers legendaires, qui sont pourtant en euros : sans
  // lui on ne sait pas si la main est en argent reel, et une prime en jetons fictifs
  // depasserait allegrement les 10 000 du palier 11.
  if (!(bounty > 0) || !(buyIn > 0)) {
    return 0;
  }
  for (let i = ABSOLUTES.length - 1; i >= 0; i--) {
    if (bounty >= ABSOLUTES[i]) {
      return 11 + i;
    }
  }
  let level = 0;
  for (let i = 0; i < MULTIPLES.length; i++) {
    // la tolerance absorbe l'arrondi a deux decimales pose par ReplayPlayer
    if (bounty >= MULTIPLES[i] * buyIn - 0.0001) {
      level = i + 1;
    }
  }
  return level;
}
